<template>
    <div class="ReportPreview">
        <div v-loading="pdfLoading" v-if="reportInfoData.previewimagelist.length === 0" class="pdf_box">
            <pdf v-for="item in pageCount" :key="item" :src="reportInfoData.fullfileurl" :page="item" />
        </div>
        <div v-else v-loading="isSuccess" class="content_box">
            <img v-for="(item, index) in reportInfoData.previewimagelist" :key="index" v-lazy="item.atturl" alt="">
        </div>
        <div class="previe_pop_wrap">
            <PreviewTipsPop @feetcallback='feetcallback' ref="previewfinishpop"></PreviewTipsPop>
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf'
import {getPreviewReportInfo} from 'api/reportApi'
import PreviewTipsPop from 'views/reportPc/reportdetail/components/PreviewTipsPop'
import {mapActions, mapGetters} from 'vuex'
import $ from 'jquery'
export default {
    name: 'ReportPreview',
    data() {
        return {
            pageCount: '', // pdf文件总页数
            pdfLoading: true,
            isSuccess: true,
            showPop: true,
            reportInfoData: {
                fullfileurl: '',
                previewimagelist: []
            }
        }
    },
    mounted() {
        this.findPreviewReportInfo(parseInt(this.$route.query.retype))
    },
    methods: {
        // 回到顶部
        goTop() {
            $("html,body").animate({
                scrollTop: 0
            }, 200)
        },
        feetcallback() {
            this.showPop = false
            this.findPreviewReportInfo(1)
            this.goTop()
        },
        // 获取预览报告信息
        findPreviewReportInfo(type) {
            this.isSuccess = true
            // this.setLoading(true)
            var params = {
                reportid: this.$route.query.reportid,
                // reportid: '9y22LRiW0RXmY6p4',
                // reportid: 'K8guBzm02F0HHHWO',
                retype: type
            }
            getPreviewReportInfo({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    // console.log(data.data)
                    if (parseInt(this.$route.query.retype) === 1 && data.data.isjoin === 0) {
                        this.$router.push({name: 'ReportDetails', query: {reportid: this.$route.query.reportid}})
                    } else {
                        this.reportInfoData = data.data
                        this.isSuccess = false
                        this.previewEnd()
                        // setTimeout(()=>{
                        //     this.previewEnd()
                        // }, 3000)
                        // this.reportInfoData.previewimagelist = []
                        if (this.reportInfoData.previewimagelist.length === 0) {
                            this.pdfLoading = true
                            // console.log('pdf:', pdf)
                            // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
                            //20201229增加，如果文件大小大于5M，则直接打开PDF，不用加载
                            if(this.reportInfoData.filesize>=5*1000*1000){
                                location.href=this.reportInfoData.fullfileurl
                            }
                            else{
                                if (this.reportInfoData.fullfileurl) {
                                    this.reportInfoData.fullfileurlobj = pdf.createLoadingTask(this.reportInfoData.fullfileurl)
                                    // this.reportInfoData.fullfileurlobj = pdf.createLoadingTask('https://cdn01-img.capwhale.com/kmc/report/20220308/440811abe15344a08e14aa203a91f08a.pdf?e=1646733352&token=jKVH4pSWd53fmmdrJhDoF5jwpAcc_IrnsQyRGOm2:kxmHpswK76fKY4DOiERG4PnJIP0=')
                                    this.reportInfoData.fullfileurlobj.then(pdf => {
                                        // console.log('pdf', pdf)
                                        this.pageCount = pdf.numPages
                                        this.pdfLoading = false
                                    })
                                }
                            }
                        }
                    }
                },
                error: data => {
                    // console.log('error：', data)
                    // this.setLoading(false)
                    this.isSuccess = true
                    this.$message.error(data.msg)
                }
            })
        },
        // 预览完成
        previewEnd() {
            var _this = this
            window.onscroll = function (){
                var marginBot = 0
                if (document.documentElement.scrollTop){
                    marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop+document.body.scrollTop) - document.documentElement.clientHeight
                    // console.log('1:', marginBot)
                } else {
                    marginBot = document.body.scrollHeight - document.body.scrollTop - document.body.clientHeight
                    // console.log('2:', marginBot)
                }
                if(marginBot <= 1) {
                // if(marginBot <= 0) {
                    //do something
                    // console.log('3:', marginBot)
                    // alert('已到达页面底部')
                    $(document).ready(function(){
                        if (_this.showPop && _this.reportInfoData.previewimagelist.length > 0 && parseInt(_this.$route.query.retype) === 2) {
                            _this.showPop = false
                            _this.$refs.previewfinishpop.openDialog(_this.reportInfoData)
                        }
                    })
                    // if (_this.showPop && _this.reportInfoData.previewimagelist.length > 0 && parseInt(_this.$route.query.retype) === 2) {
                    //     _this.showPop = false
                    //     _this.$refs.previewfinishpop.openDialog(_this.reportInfoData)
                    // }
                    // window.onload = function() {
                    //     if (_this.showPop && _this.reportInfoData.previewimagelist.length > 0) {
                    //         _this.showPop = false
                    //         _this.$refs.previewfinishpop.openDialog(_this.reportInfoData)
                    //     }
                    // }
                }
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        user: function(newVal, oldVal) {
            if (newVal != oldVal) {
                if (this.user.isLogin) {
                    this.findPreviewReportInfo(parseInt(this.$route.query.retype))
                }
            }
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        PreviewTipsPop,
        pdf
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .ReportPreview {
        font-family:PingFangSC-Regular,PingFang SC;
        // min-height: 400px;
        .pdf_box {
            min-height: 400px;
            margin: 0 auto;
            width: 1200px;
            box-sizing: border-box;
            padding: 0 10px;
            // margin-top: 30px;
            // background-color: green;
            &>span:nth-last-of-type(1){
                display: none!important;
            }
        }
        .content_box {
            // background-color: pink;
            margin: 0 auto;
            width: 1200px;
            padding: 0 10px;
            // margin-top: 30px;
            box-sizing: border-box;
            min-height: 460px;
            &>img {
                width: 1180px;
            }
        }
    }
</style>
<style lang="scss">
    .previe_pop_wrap {
        .el-dialog__wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: left;
        }
        .el-dialog {
            margin: 0!important;
            width: 560px;
        }
        .el-dialog__header {
            padding: 0!important;
            height: 40px;
            display: flex;
            align-items: center;
            // box-shadow:0px 0px 6px 0px rgba(0,0,0,0.3);
            .el-dialog__title {
                font-size: 14px;
                line-height:20px;
                padding-left: 20px;
            }
            .el-dialog__headerbtn {
                font-size: 20px;
                top: 10px;
            }
        }
        .el-dialog .el-dialog__body {
            // padding: 6px;
            padding-top: 46px;
            height: 320px;
            box-sizing: border-box;
        }
    }
// </style>
// <style lang="scss" type="text/scss" scope>
    // body::-webkit-scrollbar {
    //     display: none!important;
    // }
</style>